import * as React from 'react';
import { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Button, Grid } from "@mui/material";
import { sortByDirection } from "../../../../../../utils/utils";
import { formatDefaultValueSelect } from "../../../../../../utils/mask";
import styles from "../../../FiltrosReports/styles.module.scss";


const ModalValidarEmLote = ({
                                open, onClose, data = {},
                                onConfirm = data => {},
                                onCancel = () => {
                                },
                            }) => {

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 800,
        bgcolor: 'background.paper',
        borderRadius: '16px',
        p: 4,
    };

    const [dataInicio, setDataInicio] = useState('');
    const [dataFim, setDataFim] = useState('');
    const [agente, setAgente] = useState(null);

    const [errors, setErrors] = useState({
        agente: false,
        dataInicio: false,
        dataFim: false,
    });

    const handleConfirm = () => {
        const hasErrors = {
            agente: !agente,
            dataInicio: !dataInicio,
            dataFim: !dataFim,
        };

        setErrors(hasErrors);

        const hasAnyError = Object.values(hasErrors).some(Boolean);
        if (hasAnyError) {
            return;
        }

        const data = {
            inicio: dataInicio,
            fim: dataFim,
            cpfAtendente: agente,
        };

        onConfirm(data);
    }

    function handleDataInicioChange(event) {
        const newValue = event?.target?.value ?? event?.currentTarget?.value ?? event;
        setDataInicio(newValue);
    }

    function handleDataFimChage(event) {
        const newValue = event?.target?.value ?? event?.currentTarget?.value ?? event;
        setDataFim(newValue)
    }

    function handleAgente(event) {
        const newValue = event?.target?.value ?? event?.currentTarget?.value ?? event;
        setAgente(newValue);
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>

                <Grid container spacing={2} className={styles.big_container}>
                    <Typography component="h1" mb={3} mt={2} sx={{fontWeight: 'bold'}}>
                        Tornar atendimentos válidos em lote.
                    </Typography>
                    {/* LINHA 1 */}
                    <Grid container item spacing={2} className={styles.content_gerencial}>
                        <Grid container>
                            <Grid item md={12}>
                                <div>
                                    <div>
                                        <label htmlFor="input-canal">Selecionar atendente</label>
                                    </div>
                                    <select
                                        value={agente?.cpf}
                                        className="correct-color"
                                        onChange={handleAgente}
                                    >
                                        <option value={null}>{'Todos'}</option>
                                        {sortByDirection(data?.atendentes, 'nome').map((at, idx) => (
                                            <option key={idx} value={at?.cpf}>
                                                {formatDefaultValueSelect(at.nome)}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.agente && <p style={{ color: 'red', margin: 0 }}>Campo obrigatório</p>}
                                </div>
                            </Grid>

                            <Grid container spacing={2}>
                                {/* Data Início */}
                                <Grid item md={6}>
                                    <div>
                                        <div>
                                            <label htmlFor="dataInicio">Data inicial</label>
                                        </div>
                                        <input
                                            value={dataInicio ?? ""}
                                            id="dataInicio"
                                            name="dataInicio"
                                            type="date"
                                            max={"9999-12-31"}
                                            // className="date-picker"
                                            onChange={handleDataInicioChange}
                                        />
                                        {errors.dataInicio && <p style={{ color: 'red', margin: 0 }}>Campo obrigatório</p>}
                                    </div>
                                </Grid>


                                {/* Data Fim */}
                                <Grid item md={6}>
                                    <div>
                                        <div>
                                            <label htmlFor="dataFinal">Data final</label>
                                        </div>
                                        <input
                                            value={dataFim ?? ""}
                                            id="dataFinal"
                                            name="dataFinal"
                                            type="date"
                                            max={"9999-12-31"}
                                            onChange={handleDataFimChage}
                                        />
                                        {errors.dataFim && <p style={{ color: 'red', margin: 0 }}>Campo obrigatório</p>}
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} justifyContent="center" mt={3}>
                        <Grid item>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: '#0045FF', // azul
                                    color: '#fff',
                                    borderRadius: '6px',
                                    textTransform: 'none',
                                    '&:hover': {
                                        backgroundColor: '#0030cc',
                                    },
                                    minWidth: '100px',
                                }}
                                onClick={handleConfirm}
                            >
                                Validar
                            </Button>
                        </Grid>

                        <Grid item>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: '#FF0000', // vermelho
                                    color: '#fff',
                                    borderRadius: '6px',
                                    textTransform: 'none',
                                    '&:hover': {
                                        backgroundColor: '#cc0000',
                                    },
                                    minWidth: '100px',
                                }}
                                onClick={onCancel}
                            >
                                Cancelar
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Modal>
    );
};

export default ModalValidarEmLote;
